
import { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { LoginResponseType } from "../../redux/auth/authTypes";
import {
  resetNotificationCount,
  setAttendence,
  setNotificationCount,
} from "../../redux/notification";
import { initializeSocket } from "../../utils/commonFunctions";


type AppProps = {
  loginData: LoginResponseType;
  dispatchSetNotificationCount: (data: any) => void;
  dispatchResetNotificationCount: () => void;
  dispatchsetAttendence: (data:any) => void;
};

const Socket = ({
  loginData,
  dispatchSetNotificationCount,
  dispatchResetNotificationCount,
  dispatchsetAttendence
}: AppProps) => {
  const leaveApproveBy = localStorage.getItem("leaveApproveBy");
  const checkInScheduleData = localStorage.getItem("checkInScheduleData");

  const socket = initializeSocket(Number(loginData?.user_id));

  useEffect(() => {
    if (!socket) return;

    socket.on("connect", () => {
      const engine = socket.io.engine;
      engine.once("upgrade", () => { });
    });

    socket.on("send_count", (data: any) => {
      if (data?.attendence) {
        dispatchsetAttendence({ attendence: data.attendence });
      }
      else {
        dispatchsetAttendence({ attendence: null });
      }
      if (data?.count) {
        dispatchSetNotificationCount({ count: data.count });
      }
      else {
        dispatchSetNotificationCount({ count: 0 });
      }
    });


    socket.on("disconnect", (reason: any) => {
      // console.log("Socket disconnected:", reason);
    });
  }, [loginData?.user_id, leaveApproveBy, checkInScheduleData]);

  return null;
};

const mapStateToProps = (state: RootState) => ({
  loginData: state.auth.loginData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchSetNotificationCount: (data: any) =>
    dispatch(setNotificationCount(data)),
  dispatchResetNotificationCount: () => dispatch(resetNotificationCount()),
  dispatchsetAttendence:(data: any) =>dispatch(setAttendence(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Socket);
